"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const actions_1 = require("./actions");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ConfirmationDialog = ({ heading, subHead, description, buttons }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, cx } = useStyles();
    const handleClose = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW));
    };
    return (<Dialog_1.default open sx={{
            '& .MuiPaper-root': {
                minWidth: 520,
            },
        }}>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          {heading}
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default fontSize="small"/>
      </IconButton_1.default>
      <DialogContent_1.default>
        <Typography_1.default gutterBottom variant="h6" className={cx(classes.weight400, classes.title)}>
          {subHead}
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="body2" className={classes.textTertiary}>
          {description}
        </Typography_1.default>
      </DialogContent_1.default>
      <DialogActions_1.default className={classes.dialogAction}>
        {buttons.map((button) => (<Button_1.default key={button.label} onClick={button.action} variant={button.variant} size="small">
            {button.label}
          </Button_1.default>))}
      </DialogActions_1.default>
    </Dialog_1.default>);
};
exports.default = ConfirmationDialog;
